import { cn } from "@/lib/utils"
import { Link } from "@tanstack/react-router"

interface LogoProps {
  className?: string
  textClassName?: string
  size?: "sm" | "md" | "lg"
  imgClassName?: string
}

export function Logo({ className, size = "md", imgClassName }: LogoProps) {
  const sizes = {
    sm: {
      wrapper: "w-7 h-7",
      text: "text-lg",
    },
    md: {
      wrapper: "w-14 h-14",
      text: "text-xl",
    },
    lg: {
      wrapper: "w-16 h-16",
      text: "text-2xl",
    },
  }

  const s = sizes[size]

  return (
    <Link
      to="/"
      className={cn("group flex flex-shrink-0 items-center gap-3", className)}
      aria-label="Orchestrate home"
    >
      <div
        className={cn(
          s.wrapper,
          "flex items-center justify-center overflow-hidden rounded-lg transition-transform duration-200 group-hover:scale-110",
        )}
      >
        <img
          src="/images/logo.png"
          alt="Orchestrate Logo"
          className={cn("h-full w-full object-contain", imgClassName)}
          width={s.wrapper.match(/\d+/)?.[0]}
          height={s.wrapper.match(/\d+/)?.[0]}
        />
      </div>

      <span className={cn("font-display font-semibold tracking-tight", s.text, "text-ink")}>
        Orchestrate
      </span>
    </Link>
  )
}
